export const OPEN_MENU = 'menu/OPEN_MENU'
export const CLOSE_MENU = 'menu/CLOSE_MENU'
export const TOGGLE_MENU = 'menu/TOGGLE_MENU'
export const GO_TO_MENU_ROUTE = 'menu/GO_TO_MENU_ROUTE'
export const GO_TO_MENU_ROUTE_AND_OPEN = 'menu/GO_TO_MENU_ROUTE_AND_OPEN'
export const RESET = 'menu/RESET'
